import {Injectable, Inject} from '@angular/core';
import {Observable, Subject} from 'rxjs/Rx';
import * as _ from 'lodash';

import 'firebase/database';
import { AngularFireList, AngularFireDatabase } from 'angularfire2/database';




@Injectable()
export class FamilyService {
  sdkDb: any;
  public alumnos: AngularFireList<any>;

  constructor(private db: AngularFireDatabase) {

  }

  findFamily(key: string): Observable<any> {

    return this.db.object( '/' + key).valueChanges();
  }

  findChildren(key: string): Observable<any> {

    return this.db.list( '/' + key).valueChanges();
  }

  callAlumno(key: string, grado: string, nombre: string, familyKey: string, familiaSelected: string): Observable<any> {
    return this.db.object('/' + familiaSelected + '/' + key + '/retirado').valueChanges();
  }



  findKeyRetirado(key: string): Observable<any> {
    return this.db.object('/retirados/' + key).valueChanges();
  }

  confirmRetirado(key, grado, nombre, familiaSelected): void {
    const obj = {'nombre': nombre, 'retiraPor':''}
    const obj2 = {'retirado': true, 'retiraPor':''}
    const obj3 = {'nombre': nombre, 'grado': grado, 'retiraPor':''}
            const keyRetirado0 = this.db.list('/grado' + grado).push(obj).key;
            const keyRetirado = this.db.list('/retirados').push(obj2).key;
            const keyRetirado2 = this.db.list('/todos').push(obj3).key;
            this.db.object('/grado' + grado + '/' + keyRetirado0 + '/key').set(keyRetirado0);
            this.db.object('/' + familiaSelected + '/' + key + '/retirado').set(keyRetirado);
            this.db.object('/' + familiaSelected + '/' + key + '/retiradoPor').set('');
            this.db.object('/todos/' + keyRetirado2 + '/key').set(keyRetirado2);
            console.log('Se retira el alumno:' + nombre);
  }

  confirmRetiradoPorOtraFamilia(key, grado, nombre, familiaSelected, keyFamiliaQueRetira, surnameFamiliaQueRetira): void {
    console.log('receive ->', {key, grado, nombre, familiaSelected, keyFamiliaQueRetira, surnameFamiliaQueRetira})
    const obj = {'nombre': nombre, 'retiraPor':surnameFamiliaQueRetira}
    const obj2 = {'retirado': true, 'retiraPor':surnameFamiliaQueRetira}
    const obj3 = {'nombre': nombre, 'grado': grado, 'retiraPor':surnameFamiliaQueRetira}
    const keyRetirado0 = this.db.list('/grado' + grado).push(obj).key;
    const keyRetirado = this.db.list('/retirados').push(obj2).key;
    const keyRetirado2 = this.db.list('/todos').push(obj3).key;
    this.db.object('/grado' + grado + '/' + keyRetirado0 + '/key').set(keyRetirado0);
    this.db.object('/' + familiaSelected + '/' + key + '/retirado').set(keyRetirado);
    this.db.object('/' + familiaSelected + '/' + key + '/retiradoPor').set(surnameFamiliaQueRetira);
    this.db.object('/todos/' + keyRetirado2 + '/key').set(keyRetirado2);
    console.log('Se retira el alumno:' + nombre);
  }

  resetStateInFamily(familyKey, key): void {
    console.log('Cambio el estado del alumno en el popup');
    this.db.object('/' + familyKey + '/' + key + '/retirado').set(0);
  }

  removeFromGradoAndAll(nombre, grado): void {
    const remSubs$ = this.db.list('/todos').valueChanges().subscribe(alumnos => {
      alumnos.forEach(alumno => {
        if (alumno['nombre'] === nombre) {
          console.log('Reseteo al alumno:' + nombre + ' de todos');
          this.db.list('/todos/' + alumno['key']).remove();
          remSubs$.unsubscribe();
        }
      });
    });

    const remSubs2$ = this.db.list('/grado' + grado).valueChanges().subscribe(alumnos => {
      alumnos.forEach(alumno => {
        if (alumno['nombre'] === nombre) {
          console.log('Reseteo al alumno:' + nombre + ' del grado '+ grado);

          this.db.list('/grado' + grado + '/' + alumno['key']).remove();
          remSubs2$.unsubscribe();
        }
      });
    });


  }


  findAlumnos(): Observable<any> {
    return this.db.list( '/list').valueChanges();
  }
  isDisabled(key: string): Observable<any> {
    return this.db.object('/retirados/' + key).valueChanges();
  }

  getStatusApp(): Observable<any> {
    return this.db.object('/appReady/').valueChanges();
  }

  habilitarPadres(){
    this.db.object('/appReady').set(true);
  }

  bloquearPadres(){
    this.db.object('/appReady').set(false);
  }

}
